/**
 * calculate position for gradient rotation
 * https://stackoverflow.com/questions/9025678/how-to-get-a-rotated-linear-gradient-svg-for-use-as-a-background-image
 * @param angle angle to rotate
 * @returns position
 */
export const getGradientCords = (angle: number) => {
  const anglePI = angle * (Math.PI / 180);

  return {
    x1: Math.round(50 + Math.sin(anglePI) * 50) + '%',
    y1: Math.round(50 + Math.cos(anglePI) * 50) + '%',
    x2: Math.round(50 + Math.sin(anglePI + Math.PI) * 50) + '%',
    y2: Math.round(50 + Math.cos(anglePI + Math.PI) * 50) + '%',
  };
};

export const POINTS_MAP = {
  small: '1,6 4,6 6,11 10,1 12,6 15,6',
  medium: '1,6 4,6 6,11 10,1 12,6 15,6',
  large: '4,28 80,28 92,54 103,6 113,28 188,28',
};

export const OFFSET_MAP = {
  small: [17, 51],
  medium: [26, 78],
  large: [72, 260],
};

export const TIME_MAP = {
  small: 1200,
  medium: 1200,
  large: 1200,
};

export const SIZE_MAP = {
  small: { width: 17, height: 14 },
  medium: { width: 26, height: 20 },
  large: { width: 192, height: 56 },
};

export const STROKE_MAP = {
  small: 2,
  medium: 2,
  large: 6,
};

export const VIEWBOX_MAP = {
  small: '0 0 17 14',
  medium: '0 0 17 14',
  large: '0 0 192 56',
};
